export default {
  SET_CONTROL_TOWER_COMEX_TABLE_ITENS(state, payload) {
    state.controlTowerComexTableItens = payload;
  },
  SET_ANALISTAS_PROCESSOS(state, payload) {
    state.analistasProcessos = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
};
